import { ofType } from "redux-observable";
import { merge, of } from "rxjs";
import { catchError, map, mergeMap, switchMap } from "rxjs/operators";

import {
  readSession,
  readSessionFailed,
  readSessionSucess,
} from "./sessionActions";
import { SessionActionTypes } from "./sessionTypes";
import dataService from "../../services/dataService";
import { loginSuccess, qrSignupSuccess } from "../login/loginAction";
import { navigateAction } from "../navigation/navigationActions";

export const setSessionEpic = (action$: any, state$: any): any => {
  return action$.pipe(
    ofType(SessionActionTypes.SET_SESSION),
    switchMap((action: any): any => {
      let taskFunc = action?.signUp ? qrSignupSuccess : loginSuccess;
      return of(taskFunc());
    })
  );
};

export const readSessionEpic = (action$: any, state$: any): any => {
  return action$.pipe(
    ofType(SessionActionTypes.READ_SESSION),
    switchMap((action: any): any => {
      return dataService.getAuthData().pipe(
        map((res: any) => {
          return readSessionSucess(res.response);
        }),
        catchError((error) => of(readSessionFailed(error)))
      );
    })
  );
};

export const deleteSessionEpic = (action$: any, state$: any): any => {
  return action$.pipe(
    ofType(SessionActionTypes.DELETE_SESSION),
    switchMap((action: any): any => {
      return dataService.logout().pipe(
        map((res: any) => {
          return navigateAction("/login");
        }),
        catchError((error) => of(readSessionFailed(error)))
      );
    })
  );
};

export const loadDataEpic = (action$, state$) => {
  return action$.pipe(
    ofType(SessionActionTypes.LOAD_DATA),
    mergeMap(() => merge(of(readSession())))
  );
};
